<template>
  <footer class="footer">
    <div class="container footer-content">
      <div class="row footer-top">
        <div class="col-sm-6 col-xl-3 footer-top-contact">
          <h3>Contact Us</h3>
          <div class="hr"></div>

          <address class="mb-0">
            <p>Contact our team via:</p>

            <div>
              <a href="mailto:info@snettertonautos.co.uk"
                >info@snettertonautos.co.uk</a
              >
              <a href="tel:01953571630">01953 571630</a>
            </div>

            <p>
              Units 1 - 2 GALs Estate <br />
              Harling Road <br />
              Snetterton Business Park <br />
              Norfolk <br />
              NR16 2FS
            </p>
          </address>
        </div>

        <div class="col-sm-6 col-xl-3 mt-5 mt-sm-0 footer-top-navigation">
          <h3>Sections</h3>
          <div class="hr"></div>
          <ul>
            <li>
              <router-link
                class="footer-top-navigation-link"
                to="/our-services/"
                >Our Services</router-link
              >
            </li>
            <li>
              <router-link
                class="footer-top-navigation-link"
                to="/book-your-mot/"
              >
                Book Your MOT
              </router-link>
            </li>
            <li>
              <router-link class="footer-top-navigation-link" to="/about-us/">
                About Us
              </router-link>
            </li>
            <li>
              <router-link class="footer-top-navigation-link" to="/contact-us/"
                >Contact Us</router-link
              >
            </li>
          </ul>
        </div>

        <div class="col-sm-6 col-xl-3 mt-5 mt-xl-0 footer-top-social">
          <h3>Follow Us</h3>
          <div class="hr"></div>
          <div>
            <a
              target="_blank"
              class="footer-top-social-facebook"
              rel="noopener noreferer"
              href="https://www.facebook.com/people/Snetterton-Auto-Services-Ltd/61555478224764/"
            >
              <font-awesome-icon :icon="faFacebookF" size="lg" />
              <span>Facebook</span>
            </a>
          </div>
        </div>

        <div class="col-sm-6 col-xl-3 mt-5 mt-xl-0 footer-top-legal">
          <h3>Legal</h3>
          <div class="hr"></div>
          <ul>
            <li>
              <router-link
                class="footer-top-navigation-link"
                to="/privacy-cookie-policy/"
              >Privacy & Cookie Policy</router-link>
            </li>
          </ul>
        </div>
      </div>

      <GoogleMapsEmbed height="250" />
    </div>

    <div class="container-fluid footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <p class="footer-bottom-copyright">
              Copyright {{ copyrightDate }} &copy; Snetterton Auto-Services All
              Rights Reserved.
            </p>
          </div>

          <div class="col-lg-6">
            <p class="footer-bottom-nm-link">
              <a
                href="https://www.netmatters.co.uk"
                target="_blank"
                rel="noreferrer"
                >Website Design</a
              >&nbsp;by&nbsp;<a
                href="https://www.netmatters.co.uk"
                target="_blank"
                rel="noreferrer"
                >Netmatters</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import GoogleMapsEmbed from '@/components/partials/GoogleMapsEmbed'

export default {
  components: {
    FontAwesomeIcon,
    GoogleMapsEmbed
  },
  data () {
    return {
      name: 'main-footer',
      copyrightDate: '',
      faFacebookF
    }
  },
  mounted () {
    this.copyrightDate = new Date().getFullYear()
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/styles/variables/colors";
@import "../../assets/styles/variables/breakpoints";

.footer {
  background-color: $clr-theme-black;
  color: $white;
  font-size: 0.875rem;

  .hr {
    width: 100px;
    height: 3px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 1rem;

    @media (min-width: $sm-breakpoint) {
      margin-left: 0;
      margin-right: 0;
    }

    background-color: $clr-theme-red;
  }

  h3 {
    letter-spacing: 0.02em;
  }

  p {
    font-size: 0.875rem;
    margin: 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  address {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    a {
      display: block;
    }
  }

  &-top {
    text-align: center;

    @media (min-width: $sm-breakpoint) {
      text-align: left;
    }

    p,
    a {
      font-weight: 500;
      color: inherit;
    }

    a,
    li {
      + * {
        margin-top: 0.5rem;
      }
    }

    &-social {
      display: flex;
      flex-direction: column;

      &-facebook {
        display: flex;
        gap: 1rem;
        align-items: center;
        justify-content: center;

        @media (min-width: $sm-breakpoint) {
          justify-content: normal;
        }

        &:hover {
          svg path {
            fill: $white;
          }
        }

        svg path {
          fill: $clr-theme-red;
        }
      }
    }
  }

  &-content {
    padding-top: 38px;
    padding-bottom: 38px;

    display: flex;
    flex-direction: column;
    gap: 38px;
  }

  &-middle {
    p {
      font-weight: 400;
    }
  }

  &-bottom {
    background-color: #1a1a1a;
    padding-top: 15px;
    padding-bottom: 15px;

    &-copyright {
      font-size: 13px;

      @media (max-width: $lg-breakpoint) {
        text-align: center;
      }
    }

    &-nm-link {
      font-size: 13px;
      text-align: right;

      @media (max-width: $lg-breakpoint) {
        text-align: center;
      }

      a {
        color: $white;
        text-decoration: underline;

        &:hover {
          color: $white !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainFooter.vue